import { TRIP_STATUSES } from "../../data/static.items"

export enum TripStatus {
  OT = "On Trip",
  CP = "Completed",
  DS = "Discarded",
  NS = "Not Started",
  PS = "Paused",
  IL = "Idle",
}

export const TripStatusMap = TRIP_STATUSES.reduce((prev, status) => {
  return {
    ...prev,
    [status.id]: status.name,
  }
}, {})
export const VehicleStatusMap = {
  AV: "Available",
  NA: "Not Available",
  BR: "Broken",
  OT: "On Trip",
  RP: "Repairing",
}
export interface AssignedTripsSummary {
  vehicleInPremises: number | null
  vehicleInTransit: number | null
  vehicleCompleted: number | null
  crateInPremises: number | null
  crateInTransit: number | null
  crateCompleted: number | null
  crateInwarded: number | null
  maxBookings: number | null
}

export interface AssignedTripsSummaryVariables {
  date: Date
  departmentId: number | null
}
